export function isMadagascarPhoneNumber(number) {
  // Regular expression to match Madagascar phone numbers with correct lengths
  const madagascarRegex =
    /^((0)?(32|33|34|38)\d{7}|(\+261)?(32|33|34|38)\d{7})$/;

  // Test if the number matches the regex
  return madagascarRegex.test(number);
}
